import { trpc } from "../trpc";

interface ExtendTrialCallbacks {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
}

export function useChatbotsTrial() {
  const { data: trial, isLoading } = trpc.chatbot.trial.useQuery();

  const extendTrialMutation = trpc.chatbot.extendTrial.useMutation();

  const extendTrial = (
    input: { trialId: string },
    callbacks?: ExtendTrialCallbacks,
  ) => {
    extendTrialMutation.mutate(input, {
      onSuccess: () => {
        callbacks?.onSuccess?.();
        globalThis.location.reload();
      },
      onError: (error) => {
        callbacks?.onError?.(error);
      },
    });
  };

  return {
    trial,
    isLoading,
    extendTrial,
    isExtendingTrial: extendTrialMutation.isPending,
  };
}
